// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyUnarchiveWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface UnarchiveParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Path = '/api/web/v1/users/properties/unarchive';

/**
 * Unarchive a listing and its dupes
 */
export const RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive = (
  getParams: UnarchiveParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnarchiveParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
